import * as React from "react";

function SvgEditorNoMoneyAds(props) {
  return (
    <svg width={375} height={118} {...props}>
      <defs>
        <filter
          id="editor-no-money-ads_svg__a"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation={24.176} />
        </filter>
        <filter
          id="editor-no-money-ads_svg__b"
          height={1.012}
          width={1.47}
          colorInterpolationFilters="sRGB"
          y={-0.006}
          x={-0.235}
        >
          <feGaussianBlur stdDeviation={1.957} />
        </filter>
        <filter
          id="editor-no-money-ads_svg__c"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation={1.628} />
        </filter>
        <filter
          id="editor-no-money-ads_svg__d"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation={1.628} />
        </filter>
        <filter
          id="editor-no-money-ads_svg__e"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation={1.628} />
        </filter>
        <clipPath
          clipPathUnits="userSpaceOnUse"
          id="editor-no-money-ads_svg__f"
        >
          <path d="M0 600h600V0H0z" />
        </clipPath>
      </defs>
      <path
        d="M-1477.5-919.57c-31.657 0-57.125 25.499-57.125 57.156v14.281h1.094v804.38h1057.2v-805.72h-1.125v-12.938c0-31.657-25.468-57.156-57.125-57.156h-942.87z"
        filter="url(#editor-no-money-ads_svg__a)"
        transform="matrix(.10284 0 0 .10284 384.61 108.782)"
      />
      <g transform="matrix(.10284 0 0 .10284 332.295 25.08)">
        <path fill="#1f3042" d="M-1028.9-27.412H28.2v805.71h-1057.1z" />
        <path
          d="M-972.86-97.507c-31.657 0-57.125 25.499-57.125 57.156v14.281h1057.1v-14.281c0-31.657-25.468-57.156-57.125-57.156h-942.87z"
          fill="#333"
        />
        <path
          fill="none"
          stroke="#fff"
          filter="url(#editor-no-money-ads_svg__b)"
          d="M-5.714-10.495h20v762.86h-20z"
        />
        <path
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.484}
          d="M1.735 20.117h5.102v701.63H1.735z"
        />
        <g stroke="#fff">
          <path
            fill="none"
            filter="url(#editor-no-money-ads_svg__b)"
            d="M-189.84 9.963h20v762.86h-20z"
            transform="matrix(0 -1 -1 0 -112.63 575.08)"
          />
          <path
            fill="#fff"
            strokeWidth={0.484}
            d="M-153.205 757.47v-5.102h-701.63v5.102z"
          />
        </g>
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-441.22 29.101) scale(.63812)"
          filter="url(#editor-no-money-ads_svg__c)"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-441.22 29.101) scale(.63812)"
          fill="#324659"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-401.56 29.101) scale(.63812)"
          filter="url(#editor-no-money-ads_svg__d)"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-401.56 29.101) scale(.63812)"
          fill="#324659"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-364.95 29.101) scale(.63812)"
          filter="url(#editor-no-money-ads_svg__e)"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(-364.95 29.101) scale(.63812)"
          fill="#324659"
        />
        <circle
          r={24.392}
          cy={-147.581}
          cx={-779.766}
          transform="translate(352.1 11.996) scale(.51613)"
          fill="#324659"
        />
      </g>
      <text
        y={-731.732}
        x={-566.723}
        style={{
          lineHeight: 1.25,
          InkscapeFontSpecification: "'sans-serif, Bold'",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
        }}
        fontWeight={700}
        fontSize={192}
        fontFamily="sans-serif"
        transform="matrix(.12643 0 0 .12643 325.193 162.04)"
      >
        <tspan
          style={{
            InkscapeFontSpecification: "'sans-serif, Bold'",
            fontVariantLigatures: "normal",
            fontVariantCaps: "normal",
            fontVariantNumeric: "normal",
            fontVariantEastAsian: "normal",
          }}
          y={-731.732}
          x={-566.723}
          fill="#fff"
        >
          {"ADS"}
        </tspan>
      </text>
      <g>
        <g
          clipPath="url(#editor-no-money-ads_svg__f)"
          fillRule="evenodd"
          transform="matrix(.27756 0 0 -.27756 5.545 146.453)"
        >
          <path
            d="M437.783 275.616L417.274 473.6l-86.906-9.002 20.508-197.985z"
            fill="#e5f3be"
          />
          <path
            d="M388.324 419.405a9.305 9.305 0 00-8.297-10.215c-5.112-.53-9.686 3.186-10.216 8.299-.531 5.109 3.187 9.683 8.3 10.214 5.109.529 9.683-3.185 10.213-8.298m10.016-96.678a9.309 9.309 0 00-8.298-10.216 9.308 9.308 0 00-10.217 8.301c-.53 5.108 3.188 9.682 8.296 10.212 5.114.53 9.688-3.187 10.219-8.297m13.116 50.215c1.185-11.429-10.114-21.967-25.238-23.533-15.123-1.566-28.343 6.432-29.525 17.862-1.184 11.429 10.115 21.968 25.239 23.536 15.124 1.566 28.342-6.432 29.524-17.865m15.915-77.094l-16.14 155.817c-7.069-.732-13.456 4.452-14.19 11.523l-44.738-4.634c.734-7.072-4.454-13.455-11.524-14.187l16.14-155.815c7.072.73 13.457-4.455 14.187-11.528l44.741 4.636c-.733 7.071 4.455 13.457 11.524 14.188"
            fill="#94c64b"
          />
          <path
            d="M364.846 366.346l-.459 4.406 4.722.491c.516 4.779 3.625 7.532 7.987 7.986 8.672.898 9.551-11.128 13.865-10.679 2.042.21 2.785 1.479 2.558 3.658-.197 1.909-1.116 3.237-2.784 4.716l3.466 3.754c2.047-1.576 3.717-3.514 4.426-6.378l4.583.473.459-4.403-4.676-.485c-.421-4.359-3.236-7.312-7.687-7.773-8.174-.844-9.325 11.153-14.002 10.667-2.086-.218-3.016-1.462-2.75-4.004.222-2.181 1.338-4.084 3.304-6.219l-4.194-3.373c-2.173 1.934-3.685 4.988-4.279 7.634z"
            fill="#79aa32"
          />
          <path
            d="M267.555 354.335h26.615c7.957 0 14.463-6.507 14.463-14.46 0-7.956-6.506-14.463-14.463-14.463h-26.615z"
            fill="#5f2414"
          />
          <path
            d="M295.218 344.345a4.473 4.473 0 100-8.945 4.473 4.473 0 000 8.945"
            fill="#df8c16"
          />
          <path
            d="M171.137 449.856h75.201c15.017 0 27.305-12.285 27.305-27.304V257.195c0-15.018-12.288-27.304-27.305-27.304h-75.201c-3.938 0-7.161 3.223-7.161 7.163v205.64c0 3.94 3.223 7.162 7.161 7.162"
            fill="#5f2414"
          />
          <path
            d="M150.892 313.417c18.612-22.627-14.86-80.915-74.763-130.189-14.025-11.538-28.256-21.557-42.066-29.847v130.874c51.563 35.386 100.83 48.613 116.829 29.162M184.588 432.791c10.146-10.494.521-36.266-21.502-57.559-22.023-21.294-48.101-30.05-58.249-19.559-10.146 10.495-.52 36.264 21.503 57.56 22.022 21.294 48.101 30.051 58.248 19.558"
            fill="#f28f62"
          />
          <path
            d="M195.046 364.087c18.376-12.849 18.524-44.351.332-70.362-18.188-26.011-47.828-36.679-66.203-23.827-18.374 12.848-18.523 44.352-.332 70.361 18.19 26.008 47.831 36.678 66.203 23.828"
            fill="#db6e41"
          />
          <path
            d="M178.941 251.373l32.367 196.393 86.21-14.208-32.369-196.396z"
            fill="#e5f3be"
          />
          <path
            d="M236.95 391.929c-.837-5.072 2.596-9.859 7.668-10.697 5.073-.835 9.86 2.6 10.697 7.672.835 5.069-2.599 9.857-7.671 10.694-5.07.835-9.857-2.597-10.694-7.669m-15.805-95.901c-.835-5.071 2.598-9.861 7.668-10.693 5.069-.838 9.859 2.597 10.694 7.666.837 5.071-2.597 9.861-7.667 10.694-5.071.838-9.861-2.597-10.695-7.667m-10.077 50.913c-1.871-11.337 8.776-22.537 23.776-25.01 15.005-2.47 28.679 4.717 30.548 16.056 1.871 11.343-8.776 22.537-23.779 25.01-15.002 2.472-28.677-4.715-30.545-16.056m-20.521-76l25.476 154.567c7.014-1.157 13.698 3.636 14.857 10.65l44.379-7.314c-1.158-7.014 3.637-13.7 10.651-14.855l-25.476-154.566c-7.013 1.157-13.697-3.638-14.854-10.65l-44.379 7.315c1.155 7.012-3.637 13.697-10.654 14.853"
            fill="#94c64b"
          />
          <path
            d="M257.198 337.558l.724 4.368-4.688.773c-.224 4.802-3.165 7.738-7.488 8.451-8.605 1.42-10.204-10.532-14.485-9.829-2.027.338-2.689 1.648-2.331 3.811.31 1.891 1.308 3.161 3.059 4.539l-3.233 3.954c-2.136-1.451-3.918-3.284-4.8-6.099l-4.548.748-.721-4.371 4.641-.763c.156-4.375 2.789-7.492 7.204-8.221 8.108-1.336 9.976 10.57 14.616 9.807 2.072-.342 2.922-1.64 2.506-4.161-.357-2.162-1.581-3.996-3.673-6.013l3.985-3.617c2.284 1.799 3.976 4.76 4.73 7.364z"
            fill="#79aa32"
          />
          <path
            d="M151.349 449.856h75.199c15.018 0 27.305-12.285 27.305-27.304V257.195c0-15.018-12.287-27.304-27.305-27.304h-75.199c-3.941 0-7.163 3.223-7.163 7.163v205.64c0 3.94 3.222 7.162 7.163 7.162"
            fill="#892f1b"
          />
          <path
            d="M144.186 273.016v58.792c.799.988 1.616 1.976 2.452 2.96 22.024 25.921 48.102 40.156 58.25 31.796 10.144-8.364.52-36.154-21.502-62.077-13.027-15.332-27.472-26.575-39.2-31.471"
            fill="#5f2414"
          />
          <path
            d="M137.715 386.907c21.93-4.675 34.341-33.63 27.723-64.674-6.62-31.041-29.762-52.415-51.689-47.741-21.929 4.678-34.341 33.633-27.722 64.674 6.617 31.041 29.759 52.414 51.688 47.741"
            fill="#f28f62"
          />
          <path
            d="M204.888 367.412c10.144-10.493.52-36.264-21.502-57.558-22.025-21.295-48.103-30.049-58.25-19.556-10.148 10.493-.52 36.262 21.502 57.557 22.024 21.296 48.102 30.05 58.25 19.557"
            fill="#f28f62"
          />
          <path
            d="M89.507 280.013c10.692-12.996-8.535-46.478-42.944-74.784a212.443 212.443 0 00-12.5-9.532v74.96c25.12 14.614 47.473 19.045 55.444 9.356"
            fill="#f8a079"
          />
          <path
            d="M236.038 349.528c5.332 0 9.656-4.324 9.656-9.653 0-5.332-4.324-9.656-9.656-9.656-5.33 0-9.653 4.324-9.653 9.656 0 5.329 4.323 9.653 9.653 9.653"
            fill="#df8c16"
          />
          <path
            d="M236.038 344.736a4.863 4.863 0 100-9.728 4.864 4.864 0 000 9.728"
            fill="#b3711d"
          />
          <path
            d="M457.661 313.417c-18.612-22.627 14.86-80.915 74.761-130.189 14.024-11.54 28.256-21.559 42.064-29.847v130.874c-51.561 35.386-100.829 48.613-116.825 29.162M423.964 432.791c-10.149-10.494-.52-36.266 21.502-57.559 22.021-21.294 48.099-30.05 58.246-19.559 10.148 10.495.521 36.264-21.502 57.56-22.022 21.294-48.1 30.051-58.246 19.558"
            fill="#f28f62"
          />
          <path
            d="M413.503 364.087c-18.375-12.849-18.524-44.351-.332-70.362 18.192-26.011 47.83-36.679 66.206-23.827 18.374 12.848 18.522 44.352.332 70.361-18.192 26.008-47.831 36.678-66.206 23.828"
            fill="#db6e41"
          />
          <path
            d="M449.537 251.989l14.159 198.539-87.151 6.216-14.157-198.538z"
            fill="#e5f3be"
          />
          <path
            d="M425.782 402.18a9.306 9.306 0 00-9.945-8.62c-5.126.364-8.983 4.817-8.62 9.944.364 5.126 4.819 8.986 9.943 8.621a9.308 9.308 0 008.622-9.945m-6.914-96.95c-.365-5.126-4.82-8.983-9.944-8.622a9.31 9.31 0 00-8.622 9.947 9.31 9.31 0 009.946 8.622c5.123-.367 8.983-4.82 8.62-9.947m21.633 47.177c-.818-11.462-13.772-19.879-28.94-18.796-15.164 1.08-26.796 11.251-25.98 22.715.82 11.463 13.774 19.88 28.942 18.797 15.165-1.08 26.795-11.252 25.978-22.716m2.294-78.685l11.144 156.253c-7.09.506-12.477 6.721-11.972 13.811l-44.866 3.199c-.505-7.089-6.72-12.477-13.812-11.972l-11.144-156.254c7.091-.506 12.478-6.72 11.972-13.811l44.866-3.199c.507 7.089 6.721 12.479 13.812 11.973"
            fill="#94c64b"
          />
          <path
            d="M393.451 354.003l.315 4.415 4.734-.337c1.336 4.619 4.879 6.792 9.25 6.482 8.696-.622 7.478-12.617 11.805-12.924 2.046-.149 2.998.974 3.15 3.161.14 1.911-.534 3.378-1.923 5.124l4.07 3.097c1.739-1.908 3.047-4.107 3.248-7.051l4.597-.326-.313-4.419-4.689.335c-1.174-4.217-4.457-6.639-8.919-6.321-8.197.585-7.251 12.599-11.938 12.936-2.096.149-3.223-.917-3.404-3.467-.159-2.185.609-4.253 2.175-6.699l-4.718-2.594c-1.803 2.28-2.76 5.555-2.888 8.263z"
            fill="#79aa32"
          />
          <path
            d="M470.838 386.907c-21.93-4.675-34.341-33.63-27.723-64.674 6.617-31.041 29.759-52.415 51.688-47.741 21.927 4.678 34.342 33.63 27.719 64.674-6.616 31.041-29.756 52.414-51.684 47.741"
            fill="#f28f62"
          />
          <path
            d="M403.664 367.412c-10.145-10.493-.52-36.264 21.505-57.558 22.021-21.295 48.098-30.049 58.246-19.556 10.148 10.493.52 36.262-21.502 57.557-22.021 21.296-48.103 30.053-58.249 19.557"
            fill="#f28f62"
          />
          <path
            d="M519.045 280.013c-10.691-12.996 8.536-46.478 42.944-74.784a212.396 212.396 0 0112.497-9.532v74.957c-25.117 14.617-47.47 19.052-55.441 9.359"
            fill="#f8a079"
          />
        </g>
      </g>
      <g fill="#32c27a">
        <path d="M25.5 105.787L159.896 12l1.995 2.86-134.396 93.787z" />
        <path d="M161.891 105.787L27.496 12 25.5 14.86l134.396 93.787z" />
      </g>
      <g fill="#32c27a">
        <path d="M213.11 105.788L347.504 12l1.995 2.86-134.395 93.787z" />
        <path d="M349.5 105.787L215.104 12l-1.995 2.86 134.395 93.787z" />
      </g>
    </svg>
  );
}

export default SvgEditorNoMoneyAds;


// WEBPACK FOOTER //
// ./src/img/editor-no-money-ads.js